import {Vue} from '../../addiesaas'
import '~/components'
import './resolve-all'

import ReloadRouterLink from './ReloadRouterLink'
Vue.component(ReloadRouterLink.name, ReloadRouterLink)
